/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row } from "antd";
import { Typography } from "@mui/joy";
// import layout from "../Layout/layout";
import titleHeadLayoutWithoutBottomNav from '../UserLayout/titleHeadLayoutWithoutBottomNav';
import PubNubInstance from "./sections/ChatWindow";
// import usePubNub from "../../hooks/pubNubNotification";
import {
  updateUserIdentity,
  getProfileImage,
} from "../../redux/slices/userSlice";

const ChatInstance = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  // const identity = useSelector((state) => state?.auth?.user?.identity);
  // const mypubnub = usePubNub(identity);
  useEffect(() => {
    dispatch(getProfileImage());
  }, []);

  if (!user?.identity) {
    dispatch(updateUserIdentity());
  }

  return (
    <>
      {user && user?.identity !== null ? (
        <>
          {/* <div className="chefnet-chat"> */}
          <PubNubInstance />
          {/* </div> */}
        </>
      ) : (
        <>
          <Row className="w-full flex justify-center items-center">
            <Typography
              variant="h4"
              fontSize={16}
              fontWeight={500}
              fontFamily={"OnestRegular"}
              sx={{ textTransform: "capitalize" }}
            >
              User Identity missing. Please login again !
            </Typography>
          </Row>
        </>
      )}
    </>
  );
};

export default titleHeadLayoutWithoutBottomNav(ChatInstance);
